import { defineComponent, computed, openBlock, createElementBlock, normalizeClass, unref, normalizeStyle, renderSlot, createElementVNode, createCommentVNode } from "vue";
import { u as useFixedBarProps, a as useFixedBar } from "../../composables/useFixedBar.js";
import { u as useComponentPresetProp } from "../../composables/useComponentPreset.js";
import { s as setupScroll } from "../../composables/useScroll.js";
import { u as useColors } from "../../composables/useColors.js";
import { u as useTextColor } from "../../composables/useTextColor.js";
import { u as useBem } from "../../composables/useBem.js";
const _hoisted_1 = { class: "va-navbar__left" };
const _hoisted_2 = { class: "va-navbar__center" };
const _hoisted_3 = { class: "va-navbar__right" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    name: "VaNavbar"
  },
  __name: "VaNavbar",
  props: {
    ...useFixedBarProps,
    ...useComponentPresetProp,
    color: { type: String, default: "background-secondary" },
    textColor: { type: String },
    shape: { type: Boolean, default: false },
    shadowed: { type: Boolean, default: false },
    bordered: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const { scrollRoot, isScrolledDown } = setupScroll(props.fixed);
    const { fixedBarStyleComputed } = useFixedBar(props, isScrolledDown);
    const { getColor, shiftHSLAColor } = useColors();
    const color = computed(() => getColor(props.color));
    const { textColorComputed } = useTextColor(color);
    const shapeStyleComputed = computed(() => ({
      borderTopColor: shiftHSLAColor(color.value, { h: -1, s: -11, l: 10 })
    }));
    const computedStyle = computed(() => ({
      ...fixedBarStyleComputed.value,
      backgroundColor: color.value,
      color: textColorComputed.value,
      fill: textColorComputed.value
    }));
    const bemClasses = useBem("va-navbar", () => ({
      shadowed: props.shadowed,
      bordered: props.bordered
    }));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("header", {
        ref_key: "scrollRoot",
        ref: scrollRoot,
        class: normalizeClass(["va-navbar", unref(bemClasses)]),
        style: normalizeStyle(computedStyle.value)
      }, [
        renderSlot(_ctx.$slots, "default", {}, () => [
          createElementVNode("div", _hoisted_1, [
            renderSlot(_ctx.$slots, "left")
          ]),
          createElementVNode("div", _hoisted_2, [
            renderSlot(_ctx.$slots, "center")
          ]),
          createElementVNode("div", _hoisted_3, [
            renderSlot(_ctx.$slots, "right")
          ])
        ]),
        __props.shape ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "va-navbar__background-shape",
          style: normalizeStyle(shapeStyleComputed.value)
        }, null, 4)) : createCommentVNode("", true)
      ], 6);
    };
  }
});
export {
  _sfc_main as _
};

import '../../../VaNavbar.css';
//# sourceMappingURL=VaNavbar.vue_vue_type_script_setup_true_lang.js.map
